import { PagedFilterObservations } from "../misc/pagedFilter";
import { IdObservationData, ObservationData, ObservationResult, RemainingDaysDto, ViewEditObservationDto } from "../models/observation.model";
import { IUser } from "../models/user.model";
import ServiceBase from "./base.service";

export class ObservationsService extends ServiceBase {
  countObservations = async (ticketNumber: string): Promise<number> =>
    await this.get<number>(`observations/count/${ticketNumber}`);


  searchObservations = async (pagedFilter: PagedFilterObservations): Promise<ObservationResult> =>
    this.get(
      `observations/observationsByPublication?pageNumber=${pagedFilter.pageNumber}&pageSize=${pagedFilter.pageSize}&sortField=${pagedFilter.sortField}&sortDescending=${pagedFilter.sortDescending}&ticketNumber=${pagedFilter.ticketNumber}&email=${pagedFilter.email}`
    );

  addObservation = async (observation: ObservationData, ticketNumber?: string): Promise<void> => {
    await this.post(`observations/${ticketNumber}`, observation);
  };

  editStateObservation = async (id: IdObservationData): Promise<void> => {
    await this.put(`observations/editStateObservation/${id}`, id);
  };

  userByObservation = async (ticketNumber?: string): Promise<IUser[]> =>
    this.get(`observations/userByObservation/${ticketNumber}`);

  canViewEditObservation = async (ticketNumber?: string): Promise<ViewEditObservationDto> =>
    this.get(`observations/canViewEditObservation/${ticketNumber}`);

  getRemainingDays = async (ticketNumber?: string): Promise<RemainingDaysDto> =>
    this.get(`observations/getRemainingDays/${ticketNumber}`);
}

const observationsService = new ObservationsService();

export default observationsService;